"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupByMap = exports.mergePineOptions = exports.mergePineOptionsTyped = exports.treatAsMissingDevice = exports.treatAsMissingApplication = exports.treatAsMissingOrganization = exports.isNoApplicationForKeyResponse = exports.isNoDeviceForKeyResponse = exports.isNotFoundResponse = exports.isUnauthorizedResponse = exports.withSupervisorLockedError = exports.isFullUuid = exports.isId = exports.onlyIf = exports.notImplemented = void 0;
const tslib_1 = require("tslib");
const errors = tslib_1.__importStar(require("balena-errors"));
const notImplemented = () => {
    throw new Error('The method is not implemented.');
};
exports.notImplemented = notImplemented;
const onlyIf = (condition) => (fn) => {
    if (condition) {
        return fn;
    }
    else {
        return exports.notImplemented;
    }
};
exports.onlyIf = onlyIf;
const isId = (v) => typeof v === 'number';
exports.isId = isId;
const isFullUuid = (v) => typeof v === 'string' && (v.length === 32 || v.length === 62);
exports.isFullUuid = isFullUuid;
const SUPERVISOR_LOCKED_STATUS_CODE = 423;
const withSupervisorLockedError = (fn) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield fn();
    }
    catch (err) {
        if (err.statusCode === SUPERVISOR_LOCKED_STATUS_CODE) {
            throw new errors.BalenaSupervisorLockedError();
        }
        throw err;
    }
});
exports.withSupervisorLockedError = withSupervisorLockedError;
const isBalenaRequestErrorResponseWithCode = (error, statusCode) => error.code === 'BalenaRequestError' && error.statusCode === statusCode;
const isUnauthorizedResponse = (err) => isBalenaRequestErrorResponseWithCode(err, 401);
exports.isUnauthorizedResponse = isUnauthorizedResponse;
const isNotFoundResponse = (err) => isBalenaRequestErrorResponseWithCode(err, 404);
exports.isNotFoundResponse = isNotFoundResponse;
const isNoDeviceForKeyResponse = (err) => isBalenaRequestErrorResponseWithCode(err, 500) &&
    err.body === 'No device found to associate with the api key';
exports.isNoDeviceForKeyResponse = isNoDeviceForKeyResponse;
const isNoApplicationForKeyResponse = (err) => isBalenaRequestErrorResponseWithCode(err, 500) &&
    err.body === 'No application found to associate with the api key';
exports.isNoApplicationForKeyResponse = isNoApplicationForKeyResponse;
const treatAsMissingOrganization = (handleOrId, err) => {
    const replacementErr = new errors.BalenaOrganizationNotFound(handleOrId);
    replacementErr.stack = err.stack || '';
    throw replacementErr;
};
exports.treatAsMissingOrganization = treatAsMissingOrganization;
const treatAsMissingApplication = (slugOrUuidOrId, err) => {
    const replacementErr = new errors.BalenaApplicationNotFound(slugOrUuidOrId);
    replacementErr.stack = err.stack || '';
    throw replacementErr;
};
exports.treatAsMissingApplication = treatAsMissingApplication;
const treatAsMissingDevice = (uuidOrId, err) => {
    const replacementErr = new errors.BalenaDeviceNotFound(uuidOrId);
    replacementErr.stack = err.stack || '';
    throw replacementErr;
};
exports.treatAsMissingDevice = treatAsMissingDevice;
// TODO: Make it so that it also infers the extras param
function mergePineOptionsTyped(defaults, extras) {
    return mergePineOptions(defaults, extras);
}
exports.mergePineOptionsTyped = mergePineOptionsTyped;
const knownPineOptionKeys = new Set([
    '$top',
    '$skip',
    '$select',
    '$expand',
    '$filter',
    '$orderby',
]);
const passthroughPineOptionKeys = ['$top', '$skip', '$orderby'];
function mergePineOptions(defaults, extras, replace$selects) {
    if (!extras) {
        return defaults;
    }
    // TOOD: Consider dropping in the next major
    const unknownPineOption = Object.keys(extras).find((key) => !knownPineOptionKeys.has(key));
    if (unknownPineOption != null) {
        throw new Error(`Unknown pine option: ${unknownPineOption}`);
    }
    const result = Object.assign({}, defaults);
    if (extras.$select != null) {
        const extraSelect = extras.$select == null ||
            Array.isArray(extras.$select) ||
            extras.$select === '*'
            ? // TS should be able to infer this
                extras.$select
            : [extras.$select];
        if (replace$selects) {
            result.$select = extraSelect;
        }
        else if (extraSelect === '*') {
            result.$select = '*';
        }
        else {
            result.$select = [
                ...(typeof result.$select === 'string'
                    ? [result.$select]
                    : Array.isArray(result.$select)
                        ? result.$select
                        : []),
                ...(extraSelect !== null && extraSelect !== void 0 ? extraSelect : []),
            ];
        }
    }
    for (const key of passthroughPineOptionKeys) {
        if (key in extras) {
            // @ts-expect-error
            result[key] = extras[key];
        }
    }
    if (extras.$filter != null) {
        result.$filter =
            defaults.$filter != null
                ? {
                    $and: [defaults.$filter, extras.$filter],
                }
                : extras.$filter;
    }
    if (extras.$expand != null) {
        result.$expand = mergeExpandOptions(defaults.$expand, extras.$expand, replace$selects);
    }
    return result;
}
exports.mergePineOptions = mergePineOptions;
const mergeExpandOptions = (defaultExpand, extraExpand, replace$selects) => {
    var _a;
    if (defaultExpand == null) {
        return extraExpand;
    }
    // We only need to clone the defaultExpand as it's the only one we mutate
    const $defaultExpand = convertExpandToObject(defaultExpand, true);
    const $extraExpand = convertExpandToObject(extraExpand);
    for (const expandKey of Object.keys($extraExpand || {})) {
        $defaultExpand[expandKey] = mergePineOptions((_a = $defaultExpand[expandKey]) !== null && _a !== void 0 ? _a : {}, $extraExpand[expandKey], replace$selects);
    }
    return $defaultExpand;
};
// Converts a valid expand object in any format into a new object
// containing (at most) $expand, $filter and $select keys
const convertExpandToObject = (expandOption, cloneIfNeeded = false) => {
    if (expandOption == null) {
        return {};
    }
    if (typeof expandOption === 'string') {
        return {
            [expandOption]: {},
        };
    }
    if (Array.isArray(expandOption)) {
        // Reduce the array into a single object
        return expandOption.reduce((result, option) => Object.assign(result, typeof option === 'string' ? { [option]: {} } : option), {});
    }
    // Check the options in this object are the ones we know how to merge
    for (const expandKey of Object.keys(expandOption)) {
        const expandRelationshipOptions = expandOption[expandKey];
        // TOOD: Consider dropping in the next major
        const unknownPineOption = Object.keys(expandRelationshipOptions || {}).find((key) => !knownPineOptionKeys.has(key));
        if (unknownPineOption != null) {
            throw new Error(`Unknown pine expand options: ${unknownPineOption}`);
        }
    }
    if (cloneIfNeeded) {
        return Object.assign({}, expandOption);
    }
    return expandOption;
};
/**
 * Useful when you want to avoid having to manually parse the key
 * or when need order guarantees while iterating the keys.
 * @private
 */
const groupByMap = (entries, iteratee) => {
    const result = new Map();
    for (const entry of entries) {
        const key = iteratee(entry);
        let keyGroup = result.get(key);
        if (keyGroup == null) {
            keyGroup = [];
            result.set(key, keyGroup);
        }
        keyGroup.push(entry);
    }
    return result;
};
exports.groupByMap = groupByMap;
